


























import UiClickable from '@/components/clickables/Clickable.global.vue';
import { BooleanProp, OptionalProp } from '@/util/prop-decorators';
import moment from 'moment';
import { Component, Vue, Watch } from 'vue-property-decorator';
import VDatepicker from 'vuejs-datepicker';
import CalendarIcon from './calendar.svg?vue';
import ClearIcon from './clear.svg?vue';

@Component({ components: { CalendarIcon, VDatepicker, UiClickable, ClearIcon }, inheritAttrs: false })
export default class Datepicker extends Vue {
  @OptionalProp()
  private readonly value?: Date | string | number | null;

  @BooleanProp()
  private readonly clearable!: boolean;

  @OptionalProp()
  private readonly emptyValue: unknown;

  // Optional label prop
  @OptionalProp()
  private readonly label?: string;

  @OptionalProp()
  private readonly disabledDates?: {
    to?: Date | string | number;
    from?: Date | string | number;
    days?: number[];
    dates?: Array<Date | string | number>;
    customPredictor?: (date: Date) => boolean;
  };

  private datepickerOpen = false;

  private oldValue?: Date | string | number | null;

  private get formattedDate(): string | undefined {
    return this.value === undefined || this.value === null ? undefined : moment(this.value).format('L');
  }

  @Watch('value')
  onValueChange(): void {
    this.$emit('on-value-change', { oldValue: this.oldValue, newValue: this.value });

    this.oldValue = this.value;
  }

  private mounted(): void {
    this.oldValue = this.value;
  }
}
